import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
themeStyles.addBaseStyles('Container')(css({
    px: ['s', 's', '40px'],
}));
themeStyles.addBaseStyles('Header')(() => css({
    pt: 'm',
    borderTop: '1px solid',
    borderTopColor: 'grey.3',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    borderWidth: '1px',
    borderTopStyle: 'none',
    borderColor: 'grey.2',
    borderBottomStyle: 'solid',
}));
themeStyles.addBaseStyles('Section')(() => css({
    display: 'flex',
    flexDirection: 'column',
    gap: 'm',
}));
themeStyles.addBaseStyles('DropdownsContainer')(css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
    gap: 'm',
}));
themeStyles.addBaseStyles('DropdownWithLabel')(css({
    display: 'flex',
    flexDirection: 'column',
    flexBasis: '50%',
}));
themeStyles.addBaseStyles('LabelCopy')(css({
    fontFamily: 'bold',
    mb: 'm',
}));
themeStyles.addBaseStyles('PaymentContainer')(css({
    display: 'flex',
    flexDirection: ['column', 'column', 'row'],
}));
themeStyles.addBaseStyles('WarrantyOptionsTitle')(css({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    pb: ['12px', '12px', 'zero'],
    '& + div': {
        pb: ['12px', '12px', 'zero'],
    },
}));
themeStyles.addBaseStyles('CardContainer')(({ isSelectable, backgroundColor, isModal }) => css({
    pt: !isSelectable ? ['16px', '16px', '32px'] : isModal && '8px',
    pb: isModal && '8px',
    backgroundColor,
    px: isModal && ['20px', '20px', 0],
}));
themeStyles.addBaseStyles('WarrantyModalContainer')(css({
    display: 'flex',
    width: '100%',
    maxHeight: ['calc(100dvh - 172px)', 'calc(100dvh - 172px)', '100%'],
    flexDirection: 'column',
    overflowY: ['auto', 'auto', 'visible'],
    overflowX: ['auto', 'auto', 'visible'],
}));
themeStyles.addBaseStyles('PricingCopy')(css({
    fontWeight: 'bold',
    mr: 'xs',
    fontSize: ['14px', '14px', '18px'],
    lineHeight: ['22px', '22px', '26px'],
}));
themeStyles.addBaseStyles('PaymentCopy')(css({
    fontWeight: 'bold',
    fontSize: ['12px', '12px', '16px'],
    lineHeight: ['18px', '18px', '26px'],
}));
themeStyles.addBaseStyles('CheckboxWrapper')(css({
    marginTop: '-4px',
}));
themeStyles.addBaseStyles('StyledTooltip')(() => css({
    alignSelf: 'flex-start',
    display: 'inline-flex',
    ml: 'xxs',
}));
export default themeStyles;
